// src/components/NavBar.jsx
import {
    Toolbar,
    Typography,
    Button,
    IconButton,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
    Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { menuItems } from "../config/menuItems";
import StyledAppBar from "./StyledAppBar";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "./common/modals/ConfirmDialog";
import HomeFab from "./common/controls/HomeFab";
import { useHomeFab } from "../context/HomeFabContext";
import appHeaderImage from '../app-header.png';

export default function NavBar() {
    const { t } = useTranslation('common');
    const { isAuthenticated, role, handleLogout } = useAuth();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const { disableHomeFab } = useHomeFab();

    const appName = process.env.REACT_APP_NAME || "My App";
    const filteredItems = menuItems.filter(item => item.roles.includes(role));

    const toggleDrawer = (open) => () => setDrawerOpen(open);

    const onLogoutButtonClick = () => {
        handleLogout();
        setDrawerOpen(false);
    };

    return (
        <>
        <StyledAppBar position="sticky">
            <Toolbar>
            {/* <Typography variant="h6" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
                My App
            </Typography> */}
            <Box
              component="div"
              sx={{
                height: 40, // adjust size
                width: 'auto',
                mr: 2, // margin-right for spacing
                flexGrow: 1,
                display: "flex",     // make it a flex container
                alignItems: "center" // vertical centering
              }}
            >
              <Box
                component="img"
                src={appHeaderImage}
                alt="Animora Vet Hub"
                sx={{
                  height: 34, // adjust size
                  width: 'auto',
                  mr: 2, // margin-right for spacing
                }}
              />
            </Box>

            {/* Desktop buttons */}
            <Box sx={{ display: { xs: "none", md: "block" } }}>
                {isAuthenticated &&
                filteredItems.map(item => (
                    <Button
                    key={item.path}
                    color="inherit"
                    component={Link}
                    to={item.path}
                    >
                    {item.label}
                    </Button>
                ))}

                {isAuthenticated ? (
                <Button 
                    color="inherit" 
                    onClick={() => setConfirmDialogOpen(true)}
                >
                    Logout
                </Button>
                ) : (
                <Button color="inherit" component={Link} to="/login">
                    Login
                </Button>
                )}
            </Box>

            {/* Mobile hamburger */}
            <Box sx={{ display: { xs: "block", md: "none" } }}>
                <IconButton color="inherit" onClick={toggleDrawer(true)}>
                <MenuIcon />
                </IconButton>
            </Box>
            </Toolbar>
        </StyledAppBar>

        {/* Drawer for mobile */}
        <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
            <Box sx={{ width: 250 }}>
            {/* Drawer Header */}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", px: 2, py: 1, borderBottom: "1px solid #ddd", }} >
                    <IconButton onClick={toggleDrawer(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <List sx={{ 
                    width: 250,
                    padding: 4
                }}>
                {isAuthenticated &&
                    filteredItems.map(item => (
                    <ListItemButton
                        key={item.path} // unique key
                        component={Link}
                        to={item.path}
                        onClick={toggleDrawer(false)}
                        sx={{ mb: 1 }}
                    >
                        <ListItemText primary={item.label} />
                    </ListItemButton>
                    ))}

                {isAuthenticated ? (
                    <ListItemButton
                        key="logout"
                        onClick={() => setConfirmDialogOpen(true)}
                    >
                        <ListItemText primary={t('buttons.logout')} />
                    </ListItemButton>
                ) : (
                    null
                )}
                </List>
            </Box>
        </Drawer>
        <ConfirmDialog
            open={confirmDialogOpen}
            title="Logout"
            content="Are you sure you want to logout?"
            confirmText="Logout"
            cancelText="Cancel"
            onConfirm={onLogoutButtonClick}
            onCancel={() => setConfirmDialogOpen(false)}
        />
        {isAuthenticated ? (
            <HomeFab disabled={disableHomeFab}/>
        ) : (
            null
        )}
        </>
    );
}
